import Vue from "vue";
import "vant/lib/index.css";

import {
  Button,
  Toast,
  Dialog,
  Popup,
  ImagePreview,
  Step,
  Steps,
  Switch
} from "vant";

Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Popup);
Vue.use(Button);
Vue.use(ImagePreview);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Switch);
Vue.prototype.$appImagePriview = ImagePreview;
